import { Component } from 'solid-js';
import { config } from '../../config/environment';

interface LogoProps {
  size?: number;
  showText?: boolean;
}

/**
 * Logo Component
 * Displays the app logo from public/icons folder with app name from environment
 */
const Logo: Component<LogoProps> = (props) => {
  const size = () => props.size || 40;
  const showText = () => props.showText !== false;

  return (
    <div class="flex items-center gap-3">
      <img
        src="/icons/apple-icon-180x180.png"
        alt="Analytics Logo"
        class="rounded-lg"
        style={{
          width: `${size()}px`,
          height: `${size()}px`,
        }}
      />
      {showText() && (
        <div class="flex flex-col">
          <span class="text-sm font-bold text-gray-900 dark:text-white">
            {config.dashboard.appName}
          </span>
          <span class="text-xs text-gray-600 dark:text-gray-400">
            Analytics
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
